<template>
  <v-container>
    <div class="grey--text mb-5 text-h1">Oops!</div>
    <div class="grey--text mb-5 text-h5">We can't find the page you're looking for</div>
    <div>
      <v-btn large depressed color="primary"  router :to="{ name: 'Home' }">
        Take me somewhere better
      </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>
</style>
